/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Client from "shopify-buy";
import Products from "./Products";
import Cart from "./Cart";
import "./merch-page.m.css";
import { useUserSubscription } from "../../helper/hooks";
import { podcastRssLink } from "../../helper/api";
import { FaShoppingCart } from "react-icons/fa";
import { SubscriberOnlyNudge } from "./subscriber-only-nudge";

export function MerchPage() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [checkout, setCheckout] = useState({ lineItems: [] });
  const [products, setProducts] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [windowWidth, setWindowWidth] = useState(false);

  const userSubscription = useUserSubscription();

  const client = Client.buildClient({
    domain: "newslaundry-merchandise-store.myshopify.com",
    storefrontAccessToken: "c801e87cd24f4e034204c5849a9cb91b"
  });

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    client.checkout.create().then(res => {
      setCheckout(res);
    });

    client.product.fetchAll().then(res => {
      setProducts(res);
    });
  }, []);

  const addVariantToCart = (variantId, quantity) => {
    const lineItemsToAdd = [{ variantId, quantity: parseInt(quantity, 10) }];
    const checkoutId = checkout.id;

    return client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
      setCheckout(res);
      if (parseInt(windowWidth) > 768) {
        setIsCartOpen(true);
      }
    });
  };

  const updateQuantityInCart = (lineItemId, quantity) => {
    const checkoutId = checkout.id;
    const lineItemsToUpdate = [{ id: lineItemId, quantity: parseInt(quantity, 10) }];

    return client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
      setCheckout(res);
    });
  };

  const removeLineItemInCart = lineItemId => {
    const checkoutId = checkout.id;

    return client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
      setCheckout(res);
    });
  };

  const handleCartClose = () => {
    setIsCartOpen(false);
  };

  const showDialogFunc = () => {
    handleCartClose();
    setShowDialog(true);
  };

  const calcItems = lineItems => lineItems.map(i => i.quantity).reduce((a, b) => a + b);

  return (
    <div>
      <div styleName="header-grid">
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
          <div styleName="container">
            <h2 styleName="headline">Newslaundry Store</h2>
            <div styleName="border" />
          </div>
          <p>
            It&apos;s time to tell the world you pay to keep news free. Flaunt your love for independent media and
            inspire others.
          </p>
          <p>
            For subscribers only. If you&apos;re not one, subscribe here{" "}
            <a style={{ color: "#ec2227" }} href="/subscription">
              first.
            </a>{" "}
            Deliveries in India only, and take 2-3 weeks. Write to{" "}
            <a style={{ color: "#ec2227" }} href="mailto:store@newslaundry.com">
              store@newslaundry.com{" "}
            </a>
            for questions, feedback and delivery status.
          </p>
        </div>
        <img
          styleName=""
          alt="artwork"
          src="https://images.assettype.com/newslaundry/2020-11/cc00f47a-aee6-4c6d-b702-07215995a988/merch.jpg"
        />
      </div>
      <header>
        {!isCartOpen && (
          <div styleName="app__view-cart-wrapper">
            <div styleName="app__view-cart" onClick={() => setIsCartOpen(true)}>
              {checkout.lineItems.length ? calcItems(checkout.lineItems) : 0}
              <FaShoppingCart color="white" />
            </div>
          </div>
        )}
      </header>
      <Products products={products} client={client} addVariantToCart={addVariantToCart} />
      <Cart
        checkout={checkout}
        isCartOpen={isCartOpen}
        handleCartClose={handleCartClose}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
        subscription={userSubscription}
        dialog={showDialogFunc}
      />
      {showDialog ? <SubscriberOnlyNudge handleClose={() => setShowDialog(false)} /> : null}
    </div>
  );
}
